/**
 * Slideshow-specific motion CSS: the crossfade opacity transition and the
 * Ken Burns zoom (PresentationCrossfade, SlideStage). Injected once, the
 * same way leafletHelpers.injectLeafletStyles adds its id-guarded <style>
 * tags — this is scoped to the presentation rather than added to the shared
 * MOTION_CSS_VARS block since nothing else uses it.
 *
 * The crossfade reuses --redi-dur-slow / --redi-ease-standard (motion.ts),
 * so it collapses to near-zero under prefers-reduced-motion the same way
 * every other CSS-driven transition in the app does. The Ken Burns zoom is
 * disabled in JS instead (PresentationCrossfade only sets `zoom` when
 * !useReducedMotion()): under reduced motion the shared rule still forces
 * `animation-duration: 0.01ms`, which would otherwise play as a visible
 * instant snap to the zoomed-in frame rather than no zoom at all.
 */

const SLIDESHOW_MOTION_CSS_ID = 'slideshow-motion-css';

const SLIDESHOW_MOTION_CSS = `
[data-redi-anim="slideshow-fade"] {
  transition: opacity var(--redi-dur-slow) var(--redi-ease-standard);
}
[data-redi-anim="slideshow-progress"] {
  transition: width var(--redi-dur-slow) var(--redi-ease-standard);
}
@keyframes redi-slideshow-kenburns {
  from { transform: scale(1); }
  to { transform: scale(1.04); }
}
[data-redi-anim="slideshow-kenburns"] {
  animation: redi-slideshow-kenburns 8s cubic-bezier(0.2, 0, 0.4, 1) forwards;
}
`;

export function injectSlideshowMotionCss(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(SLIDESHOW_MOTION_CSS_ID)) return;
  const style = document.createElement('style');
  style.id = SLIDESHOW_MOTION_CSS_ID;
  style.innerHTML = SLIDESHOW_MOTION_CSS;
  document.head.appendChild(style);
}
